export default {
  ready: false,
  searchKeyWord: '',
  whiteList:null,
  appData: {
    accountid: '',
    // 是否勾选阅读协议
    isReadly: false,
    // 企业信息
    corporateInfo: {
      // 企业名称
      name: '',
      // 开发资源
      source: '',
      // 迁移完成时间
      endTime: '',
      // 实施预算(万)
      money: '',
      // 联系邮箱
      email: ''
    },
    // 认证对接模块
    authDocking: {
      // 模块是否被选中(默认选中)
      isChecked: false,
      // 有无统一认证的系统？
      hasAuth: '',
      //当前认证系统支持的协议
      supportedProtocol: '',
      // 开发时间
      workTime: {
        level1: {
          key: '初级开发者',
          value: 0
        },
        level2: {
          key: '普通开发者',
          value: 0
        },
        level3: {
          key: '熟练开发者',
          value: 0
        }
      }
    },
    // 组织和人员同步模块
    organizers: {
      // 模块是否被选中(默认选中)
      isChecked: false,
      // 人员管理信息系统
      personnelSystem: '',
      // 对接方式
      dockingMethod: '',
      // 开发时间
      workTime: {
        level1: {
          key: '初级开发者',
          value: 0
        },
        level2: {
          key: '普通开发者',
          value: 0
        },
        level3: {
          key: '熟练开发者',
          value: 0
        }
      }
    },
    // 服务邮箱对接模块
    serviceMailbox: {
      // 模块是否被选中(默认选中)
      isChecked: false,
      // 有无企业邮箱？
      enterpriseMailbox: '',
      // 当前邮箱服务支持的协议
      supportedProtocol: '',
      // 开发时间
      workTime: {
        level1: {
          key: '初级开发者',
          value: 0
        },
        level2: {
          key: '普通开发者',
          value: 0
        },
        level3: {
          key: '熟练开发者',
          value: 0
        }
      }
    },
    // 业务对接模块
    businessDocking: {
      // 模块是否被选中(默认选中)
      isChecked: false,
      // 有无存量主流软件包
      packages: '',
      // 存量主流软件包类型
      packageType: [
        {
          packageName: '金蝶-苍穹套件',
          isChecked: false,
          // 开发时间
          workTime: {
            level1: {
              key: '初级开发者',
              value: 0
            },
            level2: {
              key: '普通开发者',
              value: 0
            },
            level3: {
              key: '熟练开发者',
              value: 0
            }
          }
        },
        {
          packageName: '帆软-Fine Report 10.0',
          isChecked: false,
          // 开发时间
          workTime: {
            level1: {
              key: '初级开发者',
              value: 0
            },
            level2: {
              key: '普通开发者',
              value: 0
            },
            level3: {
              key: '熟练开发者',
              value: 0
            }
          }
        },
        {
          packageName: '帆软-Fine BI 5.0版本',
          isChecked: false,
          // 开发时间
          workTime: {
            level1: {
              key: '初级开发者',
              value: 0
            },
            level2: {
              key: '普通开发者',
              value: 0
            },
            level3: {
              key: '熟练开发者',
              value: 0
            }
          }
        },
        {
          packageName: '泛微-ecology插件',
          isChecked: false,
          // 开发时间
          workTime: {
            level1: {
              key: '初级开发者',
              value: 0
            },
            level2: {
              key: '普通开发者',
              value: 0
            },
            level3: {
              key: '熟练开发者',
              value: 0
            }
          }
        },
        {
          packageName: '致远OA插件',
          isChecked: false,
          // 开发时间
          workTime: {
            level1: {
              key: '初级开发者',
              value: 0
            },
            level2: {
              key: '普通开发者',
              value: 0
            },
            level3: {
              key: '熟练开发者',
              value: 0
            }
          }
        },
        {
          packageName: '国泰新点OA',
          isChecked: false,
          // 开发时间
          workTime: {
            level1: {
              key: '初级开发者',
              value: 0
            },
            level2: {
              key: '普通开发者',
              value: 0
            },
            level3: {
              key: '熟练开发者',
              value: 0
            }
          }
        },
        {
          packageName: '永洪OA',
          isChecked: false,
          // 开发时间
          workTime: {
            level1: {
              key: '初级开发者',
              value: 0
            },
            level2: {
              key: '普通开发者',
              value: 0
            },
            level3: {
              key: '熟练开发者',
              value: 0
            }
          }
        },
        {
          packageName: 'JePaaS',
          isChecked: false,
          // 开发时间
          workTime: {
            level1: {
              key: '初级开发者',
              value: 0
            },
            level2: {
              key: '普通开发者',
              value: 0
            },
            level3: {
              key: '熟练开发者',
              value: 0
            }
          }
        }
      ],
      // 自研IT应用
      selfDevelopedIT: {
        // 自研应用
        apps: [
          {
            name: '考勤打卡',
            // 对接方式
            dockingMethod: 'We码小程序',
            // 通用能力
            generalAbility: ['免登对接', '待办提醒', '消息通知'],
            // 增加能力
            increaseCapacity: [],
            // 应用默认选中
            isChecked: true,
            // 开发时间
            workTime: {
              level1: {
                key: '初级开发者',
                value: 0
              },
              level2: {
                key: '普通开发者',
                value: 0
              },
              level3: {
                key: '熟练开发者',
                value: 0
              }
            }
          },
          {
            name: '会议预约',
            // 对接方式
            dockingMethod: 'H5轻应用',
            // 通用能力
            generalAbility: ['免登对接', '消息通知'],
            // 增加能力
            increaseCapacity: ['日历对接', '会议服务'],
            // 应用默认选中
            isChecked: true,
            // 开发时间
            workTime: {
              level1: {
                key: '初级开发者',
                value: 0
              },
              level2: {
                key: '普通开发者',
                value: 0
              },
              level3: {
                key: '熟练开发者',
                value: 0
              }
            }
          }
        ]
      },

    },
    // 云桥网关部署
    yGateway: {
      // 模块是否被选中
      isChecked: false,
      // 选择明细 1选择有 2选择无 3未选择
      selecteDetail: {
        // 虚拟机
        virtualM: 3,
        // 公网ip
        publicIp: 3,
        // SSL证书
        sslBook: 3,
      },
      // 开发时间
      workTime: {
        level1: {
          key: '初级开发者',
          value: 0
        },
        level2: {
          key: '普通开发者',
          value: 0
        },
        level3: {
          key: '熟练开发者',
          value: 0
        }
      }
    },
    // 总工时
    workingHours: {
      level1: {
        key: '初级开发者',
        value: 0
      },
      level2: {
        key: '普通开发者',
        value: 0
      },
      level3: {
        key: '熟练开发者',
        value: 0
      }
    },
    // 服务端发送邮件需要的数据格式
    dataset: [],
    appInfo:null,
  }
};
